<template>
    <div style="background-color: white;">

        <v-row>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>
                </v-row>
        <div class="container" >
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
             

            <div v-for="(item, index) in learnermarksheet_list" :key="index">
              
            <v-col cols="12" sm="12" md="12"  v-if="item.leraner_marksheet != '' ">
                <div  style=" height:100%;border:10px solid #7d0606">
       
                <v-row dense>
                    <div class="row">
                        <div class="col-3" align="center">
                            <img :src="item.org_basic_data.trust_logo" width="160px"
                                height="160px" alt="logo" />
                        </div>
                        <div class="col-6 pt-8" align="center">
                            <span
                                style="text-transform: uppercase;font-weight:bolder;font-size:17px;color: #7d0606;font-style: italic;">
                                {{item.org_basic_data.trust_name}}
                            </span>
                            <br>
                            <span
                                style="text-transform: uppercase;font-weight:bolder;font-size:25px;color:blue;">
                                {{item.org_basic_data.school_name}}
                            </span>
                            <br>
                            <span style="text-transform: uppercase;font-weight:bolder;font-size: 17px;">{{ item.org_basic_data.address }}</span>
                            <br>
                            <span style="font-weight:bolder;font-size: 17px;">Website: {{ item.org_basic_data.website }}</span>
                            <br>
                            <span style="font-weight:bolder;font-size: 17px;">Email: {{ item.org_basic_data.email }}</span>
                        </div>
                        <div class="col-3" align="center">
                            <img :src="item.org_basic_data.school_logo" width="160px"
                                height="160px" alt="logo" />
                        </div>
                    </div>
                </v-row>
                <v-row justify="center" class="pt-2 pb-2 ml-2 mr-2" style="background-color:cyan;box-shadow:  3px 3px 3px cyan;font-size: 26px;font-family: 'Lobster', 'Pacifico', 'Dancing Script', cursive;">
                    <strong> {{ item.assessment_type }} Result Cum Progress Report</strong>
                </v-row>
                <v-row justify="center" class="pt-2 pb-2 ml-2 mr-2">
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table>
                            <thead>
                                    <tr>
                                        <th style="color: #7d0606;font-style: italic;"><center>College Index No.</center></th>
                                        <th style="color: #7d0606;font-style: italic;"><center>College U-Dise No</center></th>
                                        <th style="color: #7d0606;font-style: italic;"><center>Exam Seat No.</center></th>
                                        <th style="color: #7d0606;font-style: italic;"><center>Month/Year Of Exam</center></th>
                                        <th style="color: #7d0606;font-style: italic;"><center>Stream</center></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <td><center>{{ item.org_basic_data.school_no }}</center></td>
                                    <td><center>{{ item.udise_no }}</center></td>
                                    <td><center>{{ item.roll_no }}</center></td>
                                    <td><center>{{item.exam_month}}</center></td>
                                    <td> <center>{{ item.standard }}</center></td>
                                </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row justify="center" class="pt-2 pb-2 ml-1 mr-1">
                    <v-col cols="12" sm="12" md="12">
                       <strong> <span class="pr-9" style="color: #7d0606;font-size: 24px;">Name of the Candidate </span> <span style="font-style: italic;font-size: 22px;"> {{ item.name }} </span></strong>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                       <strong> <span class="pr-7" style="color: #7d0606;font-size: 24px;">Candidate Mother's Name</span> <span style="font-style: italic;font-size: 22px;"> {{ item.mother_name }} </span></strong>
                    </v-col>
                </v-row>
                <v-row justify="center" class="pt-2 pb-2">
                    <v-col cols="12" sm="6" md="6" style="background-color:lawngreen;box-shadow:  5px 5px 5px lawngreen;font-size: 26px;font-family: 'Lobster', 'Pacifico', 'Dancing Script', cursive;"><strong> <center>Statement Of Marks</center>  </strong></v-col>
                </v-row>
                <v-row dense style="line-height: 1.3;" class="pl-7 pr-7">
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table>
                            <thead>
                                    <tr>
                                        <th style="color: blue;font-style: italic;"><center>Subject Code</center></th>
                                        <th style="color: blue;font-style: italic;"><center>Subject Name</center></th>
                                        <th style="color: blue;font-style: italic;"><center>Maximum Marks</center></th>
                                        <th style="color: blue;font-style: italic;"><center>Marks Obtained</center></th>
                                        <th style="color: blue;font-style: italic;"><center>Grade</center></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="s, index in item.leraner_marksheet" :key="index">
                                        <td style="font-weight: bold;"><center>{{ index }}</center></td>
                                        <td style="color: #7d0606;font-style: italic;font-weight: bold;">{{ s[0].crs }}</td>
                                        <td style="font-weight: bold;"><center><span v-if="s[0].marking_type=='Marking'">{{ s[0].sub_marks }}</span><span v-else>Grade</span></center></td>
                                        <!-- <td style="font-weight: bold;"><center><span v-if="s[0].marking_type=='Marking'">{{ s[0].marks }}</span></center></td> -->
                                        <td style="font-weight: bold;"><center><span v-if="s[0].marking_type=='Marking'">{{ formatTwoDigits(s[0].marks) }}</span></center></td>
                                        <td style="font-weight: bold;"> <center><span v-if="s[0].marking_type!='Marking'">{{ s[0].marks }}</span></center></td>
                                    </tr>
                                </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row dense style="line-height: 1.3;" class="pl-7 pr-7">
                    <v-col cols="12" sm="12" md="12" class="pb-5 pt-5">
                        <table style="width: 100%;" >
                                        <th class="table_css pb-4 pt-4" style="width: 30% !important;"><center> <span class="pl-1"> Total Obtained Marks </span><span class="pl-5 pr-5" style="box-shadow:  1px 1px 1px 1px gray">{{ item.obtained_marks }}</span> </center></th>
                                        <th class="table_css pb-4 pt-4" style="width: 30% !important;"><center> <span class="pl-1"> Percentage (%) </span><span class="pl-5 pr-5" style="box-shadow:  1px 1px 1px 1px gray"> {{ item.percentage }} </span></center></th>
                                        <!-- <th v-if="item.configuration_rank=='True'" class="table_css pb-4 pt-4" style="width: 20% !important;"><center> <span class="pl-1 pr-2"> Rank </span><span class="pl-5 pr-5" style="box-shadow:  1px 1px 1px 1px gray">{{ item.rank }}</span></center></th> -->
                                        <th v-if="item.configuration_rank=='True'" class="table_css pb-4 pt-4" style="width: 20% !important;"><center> <span class="pl-1 pr-2"> Rank </span><span class="pl-5 pr-5" style="box-shadow:  1px 1px 1px 1px gray">{{ formatTwoDigits(item.rank) }}</span></center></th>
                                        <th class="table_css pb-4 pt-4" style="width: 30% !important;"><center><span class="pl-1"> Result</span> <span class="pl-5 pr-5" style="box-shadow:  1px 1px 1px 1px gray">{{item.result}}</span></center></th>
                                    
                        </table>
                    </v-col>
                </v-row>
                <v-row justify="center" class="pt-2 pb-2">
                    <v-col cols="12" sm="6" md="6" style="background-color:lawngreen;box-shadow:  5px 5px 5px lawngreen;font-size: 26px;font-family: 'Lobster', 'Pacifico', 'Dancing Script', cursive;"><strong> <center>Statement Of Attendance</center>  </strong></v-col>
                </v-row>
                <v-row dense style="line-height: 1.3;" class="pl-7 pr-7 pt-5">
                    <v-col cols="12" sm="12" md="12" v-if="item.show_crs_att_data=='True'">
                       
                        <table style="width: 100%;">
                            <thead>
                                    <tr>
                                        <th style="color: blue;font-style: italic;font-size: 15px;"><center>Subject Name</center></th>
                                        <th v-for="s, index1 in item.learner_crs_att_data" :key="index1" style="color: blue;font-style: italic;font-size: 15px;"><center>{{index1}}</center></th> 
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th style="color: blue;font-style: italic;font-size: 15px;"><center>% Attendance</center></th>
                                        <!-- <th style="font-style: italic;font-weight: bold;font-size: 15px;" v-for="s, index in item.learner_crs_att_data" :key="index"><center>{{ s[0].present }}</center></th> -->
                                        <th style="font-style: italic;font-weight: bold;font-size: 15px;" v-for="s, index in item.learner_crs_att_data" :key="index"><center>{{ s[0].perc }}</center></th>
                                    </tr>
                                    <tr>
                                        <!-- <th :colspan="att_avg_count-1" style="color: blue;font-style: italic;font-size: 15px;border: none;"><center></center></th> -->
                                        <th :colspan="item.att_avg_count"  style="color: blue;font-style: italic;font-size: 15px;border-top: none;border-right: none;text-align: end;" class="pr-4">Total Avgrage Attendance </th>
                                        <th  style="font-style: italic;font-weight: bold;font-size: 15px;border-top: none;">
                                           <span v-if="item.att_avg"> {{ item.att_avg }}</span>
                                        </th> 
                                    </tr>
                                </tbody>
                        </table>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-else>
                        <table style="width: 100%;" class="pb-4 pt-4">
                            <thead>
                            <th class="table_css pb-4 pt-4" style="width: 30% !important;color: blue;font-style: italic;font-weight: bold;"><center>Attendance </center></th>
                            <th class="table_css pb-4 pt-4" style="width: 30% !important;font-style: italic;"><center v-for="(s, index2) in item.attendance" :key="index2"> <span class="pl-5 pr-5" style="box-shadow:  1px 1px 1px 1px gray"> {{ s.present }} / {{ s.total_working_stud }} days </span></center></th>
                            <th class="table_css pb-4 pt-4" style="width: 30% !important;color: blue;font-style: italic;font-weight: bold;"><center>Total Avgrage Attendance </center></th>
                            <th class="table_css pb-4 pt-4" style="width: 30% !important;font-style: italic;"><center v-for="(s, index2) in item.attendance" :key="index2"> <span class="pl-5 pr-5" style="box-shadow:  1px 1px 1px 1px gray"> {{ s.percentage }} </span></center></th>
                            </thead>
                        </table>
                    </v-col>
                </v-row>


                <v-row dense justify="center" style="line-height: 1.3;font-weight: bold;padding-top: 30%;font-size: 25px;" class="pl-9 pr-7">
                        <v-col cols="12" sm="4" md="4"><center>Class Teacher</center></v-col>
                        <v-col cols="12" sm="4" md="4"><center>Exam Incharge</center></v-col>
                        <v-col cols="12" sm="4" md="4"><center>Principal</center></v-col>
                </v-row>
            </div>
                <div class="pagebreak" v-if="index < learnermarksheet_list.length -1  " ></div>

            </v-col>
            
       
             </div>
        </div>

    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        org: Number,
    },
    data() {
        return {
            default_value: [],
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            asd: null,
            fetch_loader: false,
            show: false,
            course_list: [],
            stud_list: [],
            awspath: "",
            registration_no: null,
            standard: null,
            div: null,
            ay: null,
            name: null,
            sur_name: null,
            leraner_marksheet: [],
            colspan: null,
            overall_grade: null,
            remark: [],
            org_basic_data: [],
            assessment_type: null,
            grade_details: [],
            inst_name: null,
            percentage: null,
            obtained_marks: null,
            totalmarks: null,
            attendance: null,
            learner_crs_att_data:null,
            standard_name:null,
            name_as_on_aadhar_card:null,
            rank:null,
            mother_name:null,
            udise_no:null,
            show_crs_att_data:null,
            configuration_rank:null,
            att_avg:null,
            att_avg_count:null,
            result:null,
            exam_month:null,
            std: null,
            div: null,
            learnermarksheet_list: null,
            sem:null
        };
    },

    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        putnull3() {
            this.show = false;
        },
       formatTwoDigits(num) {
        if (!num || num === 0) return '';
        return String(num).padStart(2, '0');
    },

        getreport() { },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                asd: this.asd,
                org: this.org,
                std: this.std,
                div: this.div,
                sem: this.sem
            };
            axios
                .post("/SanjivaniExamination/generatelearnermarksheet", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.learnermarksheet_list = res.data.learnermarksheet_list
                    }
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.sel_ay_data = localStorage.getItem("setay");
        this.asd = localStorage.getItem("setasd");
        this.registration_no = localStorage.getItem("setreg_no");
        this.std = localStorage.getItem("setstd");
        this.div = localStorage.getItem("setdiv");
        this.sem = localStorage.getItem("setsem");
        this.onload();
    },
     
};
</script>
<style scoped>
.avg {
    font-weight: 100px;
}

table,
th,
td {
    font-size: 20px;
    border: 2px solid black;
    border-collapse: collapse !important;
    height: 40px;
}

.table_css{
    font-size: 20px;
    border: 4px solid burlywood;
    border-collapse: collapse !important;
    height: 40px;
}

@media print {

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .card {
        border: none !important;
    }
    table,tr,th,td,tbody,thead{
        font-size: 25px !important;
    }

    @page {
        /* size: A4 portrait !important;
        margin-top: 0;
        padding-top: none;
        size: 11in 15.5in !important; */

        size: A4;
        margin-top: none;
        padding-top: none;
        size: 13.5in 20.5in;

        /* size: 13in 18in; */
    }
    .pagebreak {
    page-break-before: always;
  }

}
</style>
